export default `<div class="styles__CategoryList">
  <div class="column featured">
    <div class="group featured">

    </div>
  </div>
</div>`;
